module.exports = "<div class=\"container\">\n    <p class=\"text-center\">W2GO dashboard</p>\n\n</div>"